import {
    Button,
    CircularProgress,
    Grid,
    styled
} from '@mui/material';
import AppModal from 'components/AppModal';
import FlexBox from 'components/flexbox/FlexBox';
import AppTextField from 'components/input-fields/AppTextField';
import Scrollbar from 'components/ScrollBar';
import { H2, H6 } from 'components/Typography';
import { useFormik } from 'formik';
import { useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';
import axiosInstance from 'utils/axios';
import * as Yup from 'yup'; // component props interface

// styled components
const StyledAppModal = styled(AppModal)(({ theme }) => ({
    maxWidth: 600,
    minWidth: 450,
    [theme.breakpoints.down(325)]: {
        maxWidth: '100%',
    },
}));

const FormEditName = ({ open, onClose, data, onSubmissionSuccess }) => {
    const initialValues = useMemo(() => {
        return {
            nickName: data?.nickName || '',
        };
    }, [data]);
    const fieldValidationSchema = Yup.object().shape({
        nickName: Yup.string()
            .min(3, 'Too Short')
            .required('Name is Required!'),
    });
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        touched,
        setValues,
        isSubmitting,
    } = useFormik({
        initialValues,
        validationSchema: fieldValidationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                await axiosInstance.patch(`/api/prv/re-registrations/${data.id}`, values);
                onSubmissionSuccess(); 
                onClose();
                toast.success('New Data Added Successfully');
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });
    useEffect(() => {
        setValues(initialValues);
    }, [setValues, initialValues]);
    return (
        <StyledAppModal open={open} handleClose={onClose}>
            <H2 mb={2}>Edit Participant Name</H2>

            <form onSubmit={handleSubmit}>
                <Scrollbar
                    style={{
                        maxHeight: 400,
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <H6 mb={1}>Full Name</H6>
                            <AppTextField
                                fullWidth
                                size="small"
                                name="nickName"
                                placeholder="Name"
                                value={values.nickName}
                                onChange={handleChange}
                                error={Boolean(
                                    errors.nickName && touched.nickName,
                                )}
                                helperText={touched.nickName && errors.nickName}
                            />
                        </Grid>
                    </Grid>
                </Scrollbar>

                <FlexBox justifyContent="flex-end" gap={2} marginTop={4}>
                    <Button
                        fullWidth
                        size="small"
                        variant="outlined"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        size="small"
                        type="submit"
                        variant="contained"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                Loading . . .
                                <CircularProgress size={20} />
                            </>
                        ) : (
                            'Update'
                        )}
                    </Button>
                </FlexBox>
            </form>
        </StyledAppModal>
    );
};

export default FormEditName;
